import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import { BiInfoCircle } from 'react-icons/bi';
import styled from 'styled-components';

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))`
  z-index: 1000;

  & .MuiTooltip-tooltip {
    max-width: 250px;
    padding: 8px 12px;
    color: black;
    font-size: 13px;
    background-color: white;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  }
  & .MuiTooltip-arrow {
    color: rgba(0, 0, 0, 0.1);
  }
`;

const InfoTooltip = ({
  title,
  placement = 'right',
  iconSize = 15,
  children,
  color = '#ced4da',
  PopperProps,
  ...rest
}) => (
  <StyledTooltip
    title={title}
    placement={placement}
    arrow
    PopperProps={{
      ...PopperProps,
      style: {
        zIndex: 1000000,
        ...PopperProps?.style,
      },
    }}
    {...rest}
  >
    {children || (
      <span style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>
        <BiInfoCircle className="ml-1" size={iconSize} style={{ color }} />
      </span>
    )}
  </StyledTooltip>
);

InfoTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  placement: PropTypes.string,
  iconSize: PropTypes.number,
  children: PropTypes.node,
  color: PropTypes.string,
  PopperProps: PropTypes.object,
};

export { StyledTooltip };
export default InfoTooltip;
